import React from 'react';
import { CARDS_WIDTH } from '../../CharitableGiving.meta';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  onRetry?(): void;
}

export const StepErrorState = ({ onRetry }: Props) => {
  return (
    <Box maxWidth={CARDS_WIDTH} mx="auto" mt={96}>
      <ErrorState onAction={onRetry} />
    </Box>
  );
};
